// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-template-wrapper {
  padding: 6px 12px 6px 45px;
  display: inline-block;
  width: 100%;
  animation-name: left-to-right-slide-anim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.card-template-wrapper .card-warpper-info {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--card-main-wrapper-bg);
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
}
.card-template-wrapper .card-warpper-info h1 {
  color: var(--card-heading-title);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}

.card-content-sec {
  display: flex;
  padding: 12px;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--card-temp-border);
  background: var(--card-temp-bg);
  text-align: start;
}
.card-content-sec .top-sec-card {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.card-content-sec .top-sec-card h1 {
  color: var(--card-temp-h1-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  width: 100%;
}
.card-content-sec .top-sec-card .tag-name {
  flex-shrink: 0;
  border-radius: 24px;
  background: var(--sdk-gloabl-bg-secondary);
  padding: 2px 10px;
  color: var(--kore-green-kore-green-0, #04AF5F);
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.card-content-sec .middle-sec-card, .card-content-sec .card-info-more-details .medium-font-sec, .card-info-more-details .card-content-sec .medium-font-sec, .card-content-sec .card-info-more-details .small-font-sec, .card-info-more-details .card-content-sec .small-font-sec {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}
.card-content-sec .middle-sec-card p, .card-content-sec .card-info-more-details .medium-font-sec p, .card-info-more-details .card-content-sec .medium-font-sec p, .card-content-sec .card-info-more-details .small-font-sec p, .card-info-more-details .card-content-sec .small-font-sec p {
  color: var(--card-temp-p-color);
  font-size: 10px;
  font-weight: 400;
  line-height: normal;
  width: 100%;
}
.card-content-sec .middle-sec-card .amount-text, .card-content-sec .card-info-more-details .medium-font-sec .amount-text, .card-info-more-details .card-content-sec .medium-font-sec .amount-text, .card-content-sec .card-info-more-details .small-font-sec .amount-text, .card-info-more-details .card-content-sec .small-font-sec .amount-text, .card-content-sec .middle-sec-card .clickble-text, .card-content-sec .card-info-more-details .medium-font-sec .clickble-text, .card-info-more-details .card-content-sec .medium-font-sec .clickble-text, .card-content-sec .card-info-more-details .small-font-sec .clickble-text, .card-info-more-details .card-content-sec .small-font-sec .clickble-text {
  color: var(--card-temp-color);
  text-align: right;
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
  flex-shrink: 0;
  max-width: 60%;
}
.card-content-sec .middle-sec-card .clickble-text, .card-content-sec .card-info-more-details .medium-font-sec .clickble-text, .card-info-more-details .card-content-sec .medium-font-sec .clickble-text, .card-content-sec .card-info-more-details .small-font-sec .clickble-text, .card-info-more-details .card-content-sec .small-font-sec .clickble-text {
  color: var(--sdk-global-theme-color);
}
.card-content-sec .bottom-sec-card, .card-content-sec .more-sec-card {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}
.card-content-sec .bottom-sec-card h2, .card-content-sec .more-sec-card h2 {
  overflow: hidden;
  color: var(--card-temp-color);
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  width: 100%;
}
.card-content-sec .bottom-sec-card p, .card-content-sec .more-sec-card p {
  color: var(--card-temp-color);
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  flex-shrink: 0;
}
.card-content-sec .more-sec-card h2 {
  font-size: 10px;
}
.card-content-sec .more-sec-card p {
  font-size: 10px;
}
.card-content-sec .border-divider {
  background: var(--card-temp-border-divided-bg);
  width: 25px;
  height: 1px;
}
.card-content-sec .view-more-btn {
  border-radius: 4px;
  border: 1px solid var(--card-temp-view-more-border);
  width: 100%;
  background: var(--card-temp-view-more-bg);
  padding: 5px 12px;
  color: var(--card-temp-view-more-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  height: 30px;
  text-align: center;
  margin-top: 5px;
}

.card-template-wrapper-view-more-details {
  padding: 6px 12px 6px 45px;
  display: inline-block;
  width: 100%;
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.menu-wrapper-data-actions {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.menu-wrapper-data-actions .actions-slider-header-menu {
  display: flex;
  align-items: center;
  padding: 14px 15px;
  gap: 10px;
  flex-shrink: 0;
}
.menu-wrapper-data-actions .actions-slider-header-menu h1 {
  width: 100%;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close {
  width: 16px;
  height: 16px;
  border: 0;
  background: transparent;
  padding: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close svg path {
  fill: var(--sdk-gloabl-text-color);
}
.menu-wrapper-data-actions .iner-data-scroll-wraper {
  flex: 1 1 auto;
  overflow: auto;
}

.card-info-more-details {
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
}
.card-info-more-details .m-b-10 {
  margin-bottom: 10px;
}
.card-info-more-details .top-sec-card {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.card-info-more-details .top-sec-card h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 18px;
  font-weight: 700;
  line-height: 14px;
  width: 100%;
}
.card-info-more-details .top-sec-card span {
  border-radius: 4px;
  background: var(--sdk-gloabl-bg-secondary);
  flex-shrink: 0;
  color: var(--sdk-gloabl-text-color);
  text-align: right;
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  padding: 5px;
}
.card-info-more-details .middle-sec-card, .card-info-more-details .medium-font-sec, .card-info-more-details .small-font-sec, .card-info-more-details .bottom-sec-card, .card-info-more-details .card-content-sec .more-sec-card, .card-content-sec .card-info-more-details .more-sec-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
}
.card-info-more-details .middle-sec-card .img-with-text, .card-info-more-details .medium-font-sec .img-with-text, .card-info-more-details .small-font-sec .img-with-text, .card-info-more-details .bottom-sec-card .img-with-text, .card-info-more-details .card-content-sec .more-sec-card .img-with-text, .card-content-sec .card-info-more-details .more-sec-card .img-with-text {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}
.card-info-more-details .middle-sec-card .img-with-text img, .card-info-more-details .medium-font-sec .img-with-text img, .card-info-more-details .small-font-sec .img-with-text img, .card-info-more-details .bottom-sec-card .img-with-text img, .card-info-more-details .card-content-sec .more-sec-card .img-with-text img, .card-content-sec .card-info-more-details .more-sec-card .img-with-text img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.card-info-more-details .middle-sec-card .img-with-text p, .card-info-more-details .medium-font-sec .img-with-text p, .card-info-more-details .small-font-sec .img-with-text p, .card-info-more-details .bottom-sec-card .img-with-text p, .card-info-more-details .card-content-sec .more-sec-card .img-with-text p, .card-content-sec .card-info-more-details .more-sec-card .img-with-text p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  width: 100%;
}
.card-info-more-details .middle-sec-card .right-title, .card-info-more-details .medium-font-sec .right-title, .card-info-more-details .small-font-sec .right-title, .card-info-more-details .bottom-sec-card .right-title, .card-info-more-details .card-content-sec .more-sec-card .right-title, .card-content-sec .card-info-more-details .more-sec-card .right-title {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.card-info-more-details .middle-sec-card .right-title p, .card-info-more-details .medium-font-sec .right-title p, .card-info-more-details .small-font-sec .right-title p, .card-info-more-details .bottom-sec-card .right-title p, .card-info-more-details .card-content-sec .more-sec-card .right-title p, .card-content-sec .card-info-more-details .more-sec-card .right-title p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
}
.card-info-more-details .middle-sec-card .right-title img, .card-info-more-details .medium-font-sec .right-title img, .card-info-more-details .small-font-sec .right-title img, .card-info-more-details .bottom-sec-card .right-title img, .card-info-more-details .card-content-sec .more-sec-card .right-title img, .card-content-sec .card-info-more-details .more-sec-card .right-title img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.card-info-more-details .small-font-sec {
  padding: 3px 0;
}
.card-info-more-details .small-font-sec .img-with-text p {
  font-size: 12px;
}
.card-info-more-details .small-font-sec .right-title p {
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}
.card-info-more-details .medium-font-sec {
  margin-top: 5px;
}
.card-info-more-details .medium-font-sec .img-with-text p {
  font-size: 14px;
  line-height: 20px;
  color: var(--sdk-gloabl-text-color);
  font-weight: 500;
}
.card-info-more-details .medium-font-sec .right-title p {
  font-size: 20px;
  font-weight: 700;
  color: var(--sdk-gloabl-text-color);
}

.accordion-wrapper {
  padding: 10px 15px;
  display: inline-block;
  width: 100%;
}
.accordion-wrapper .accordion_item {
  display: inline-block;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--sdk-gloabl-border-color);
  margin: 2px 0;
}
.accordion-wrapper .accordion_item .accordion_heading {
  width: 100%;
  text-align: start;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 50px;
  background: var(--sdk-gloabl-bg-secondary);
  border: 0;
  padding: 10px;
}
.accordion-wrapper .accordion_item .accordion_heading[aria-expanded=true] .arrow-icon {
  transform: rotate(90deg);
}
.accordion-wrapper .accordion_item .accordion_heading p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  width: 100%;
}
.accordion-wrapper .accordion_item .accordion_heading .arrow-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.accordion-wrapper .accordion_item .accordion_heading .arrow-icon svg path {
  fill: var(--sdk-gloabl-text-color);
}
.accordion-wrapper .accordion_item .accordion_collapse {
  transition: height 0.35s ease;
  display: block;
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.accordion-wrapper .accordion_item .accordion_collapse:not(.collapse_data) {
  display: none;
  animation: none !important;
}
.accordion-wrapper .accordion_item .accordion_collapse .accordion_body {
  padding: 0 10px;
}

.card-acc-temp-sec .card-acc-temp {
  display: flex;
  width: 321px;
  padding: 10px 10px 10px 0px;
  align-items: flex-start;
  gap: 15px;
  border-bottom: 1px solid var(--sdk-gloabl-border-color);
}
.card-acc-temp-sec .card-acc-temp:last-child {
  border: 0;
}
.card-acc-temp-sec .card-acc-temp {
  cursor: pointer;
}
.card-acc-temp-sec .card-acc-temp .left-data {
  width: 100%;
}
.card-acc-temp-sec .card-acc-temp .left-data h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.card-acc-temp-sec .card-acc-temp .left-data p {
  color: var(--sdk-gloabl-text-color);
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
}
.card-acc-temp-sec .card-acc-temp .right-data {
  flex-shrink: 0;
}
.card-acc-temp-sec .card-acc-temp .right-data p {
  color: var(--sdk-gloabl-text-color);
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.regular-card-temp-container {
  padding: 0 16px;
  display: inline-block;
  width: 100%;
}
.regular-card-temp-container .rugular-card-temp {
  border-radius: 8px;
  background: var(--sdk-global-white-bg);
  display: inline-block;
  width: 100%;
  box-shadow: 0px 1px 2px 0px var(--sdk-gloabl-border-color);
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 {
  width: 100%;
  display: flex;
  align-items: normal;
  padding: 10px;
  gap: 15px;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .border-block {
  width: 4px;
  flex-shrink: 0;
  border-radius: 9px;
  background: var(--sdk-global-theme-color);
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .img-block {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .img-block.xs {
  width: 16px;
  height: 16px;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .img-block.lg {
  width: 60px;
  height: 60px;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .img-block.xlg {
  width: 80px;
  height: 80px;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .img-block figure {
  line-height: 0px;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .img-block img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .img-block img.radius-100 {
  border-radius: 100%;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .titles-info-block {
  width: 100%;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .titles-info-block h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}
.regular-card-temp-container .rugular-card-temp .card-r-h-1 .titles-info-block p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.271px;
}
.regular-card-temp-container .rugular-card-temp .r-header-card {
  border-radius: 8px 8px 0px 0px;
  background: var(--sdk-gloabl-bg-secondary);
  padding: 14px;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  border: 1px solid var(--sdk-gloabl-border-color);
}
.regular-card-temp-container .rugular-card-temp .r-header-card h1 {
  margin: 0;
}
.regular-card-temp-container .rugular-card-temp .r-body-card {
  padding: 10px 14px;
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 0px 0px 8px 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}
.regular-card-temp-container .rugular-card-temp .r-body-card .row-list-info {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.regular-card-temp-container .rugular-card-temp .r-body-card .row-list-info figure {
  line-height: 0;
  position: relative;
  top: 2px;
}
.regular-card-temp-container .rugular-card-temp .r-body-card .row-list-info figure img {
  width: 16px;
  height: 16px;
}
.regular-card-temp-container .rugular-card-temp .r-body-card .row-list-info p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.3px;
}
.regular-card-temp-container .rugular-card-temp .btn-action-card {
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  background: var(--sdk-global-theme-color);
  border: 1px solid var(--sdk-global-theme-color);
  padding: 13px;
  text-align: center;
  color: var(--sdk-global-white);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/cardTemplate/cardTemplate.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,qBAAA;EACA,WAAA;EACA,wCAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AACJ;AACI;EACI,kBAAA;EACA,gDAAA;EACA,uCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AACR;AACQ;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACZ;;AAIA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,+BAAA;EACA,iBAAA;AADJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AADR;AAGQ;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AADZ;AAIQ;EACI,cAAA;EACA,mBAAA;EACA,0CAAA;EACA,iBAAA;EACA,8CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAFZ;AAMI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AAJR;AAMQ;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAJZ;AAOQ;EACI,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AALZ;AAQQ;EAEI,oCAAA;AAPZ;AAWI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AATR;AAWQ;EACI,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AATZ;AAYQ;EACI,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAVZ;AAiBQ;EACI,eAAA;AAfZ;AAkBQ;EACI,eAAA;AAhBZ;AAoBI;EACI,8CAAA;EACA,WAAA;EACA,WAAA;AAlBR;AAqBI;EACI,kBAAA;EACA,mDAAA;EACA,WAAA;EACA,yCAAA;EACA,iBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAnBR;;AAuBA;EACI,0BAAA;EACA,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AApBJ;;AAwBA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AArBJ;AAsBI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AApBR;AAqBQ;EACI,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAnBZ;AAqBQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAnBZ;AAqBgB;EACI,kCAAA;AAnBpB;AAwBI;EACI,cAAA;EACA,cAAA;AAtBR;;AA0BA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;AAvBJ;AAyBI;EACI,mBAAA;AAvBR;AA0BI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAxBR;AA0BQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAxBZ;AA2BQ;EACI,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,mCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAzBZ;AA6BI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA3BR;AA6BQ;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;AA3BZ;AA6BY;EACI,WAAA;EACA,YAAA;EACA,cAAA;AA3BhB;AA8BY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AA5BhB;AAgCQ;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AA9BZ;AAgCY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA9BhB;AAiCY;EACI,WAAA;EACA,YAAA;EACA,cAAA;AA/BhB;AAoCI;EAEI,cAAA;AAnCR;AAsCY;EACI,eAAA;AApChB;AAyCY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAvChB;AA4CI;EAEI,eAAA;AA3CR;AA8CY;EACI,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;AA5ChB;AAiDY;EACI,eAAA;EACA,gBAAA;EACA,mCAAA;AA/ChB;;AAuDA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;AApDJ;AAqDI;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gDAAA;EACA,aAAA;AAnDR;AAoDQ;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,0CAAA;EACA,SAAA;EACA,aAAA;AAlDZ;AAoDgB;EACI,wBAAA;AAlDpB;AAqDY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAnDhB;AAqDY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAnDhB;AAqDoB;EACI,kCAAA;AAnDxB;AAwDQ;EACI,6BAAA;EACA,cAAA;EACA,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AAtDZ;AAuDY;EACI,aAAA;EACA,0BAAA;AArDhB;AAuDY;EACI,eAAA;AArDhB;;AA4DI;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;EACA,uDAAA;AAzDR;AA0DQ;EACI,SAAA;AAxDZ;AAgDI;EAUI,eAAA;AAvDR;AAwDQ;EACI,WAAA;AAtDZ;AAuDY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArDhB;AAuDY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArDhB;AAwDQ;EACI,cAAA;AAtDZ;AAuDY;EACI,mCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArDhB;;AA2DA;EACI,eAAA;EACA,qBAAA;EACA,WAAA;AAxDJ;AAyDI;EACI,kBAAA;EACA,sCAAA;EACA,qBAAA;EACA,WAAA;EACA,0DAAA;AAvDR;AAwDQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAtDZ;AAuDY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;AArDhB;AAuDY;EACI,cAAA;EACA,WAAA;EACA,YAAA;AArDhB;AAsDgB;EACI,WAAA;EACA,YAAA;AApDpB;AAsDgB;EACI,WAAA;EACA,YAAA;AApDpB;AAsDgB;EACI,WAAA;EACA,YAAA;AApDpB;AAsDgB;EACI,gBAAA;AApDpB;AAsDgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AApDpB;AAqDoB;EACI,mBAAA;AAnDxB;AAuDY;EACI,WAAA;AArDhB;AAyDgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAvDpB;AA6DgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA3DpB;AAmEQ;EACI,8BAAA;EACA,0CAAA;EACA,aAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;AAjEZ;AAkEY;EACI,SAAA;AAhEhB;AAmEQ;EACI,kBAAA;EACA,gDAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAjEZ;AAkEY;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AAhEhB;AAiEgB;EACI,cAAA;EACA,kBAAA;EACA,QAAA;AA/DpB;AAgEoB;EACI,WAAA;EACA,YAAA;AA9DxB;AAiEgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AA/DpB;AAmEQ;EACI,WAAA;EACA,8BAAA;EACA,yCAAA;EACA,+CAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAjEZ","sourcesContent":[".card-template-wrapper {\n    padding: 6px 12px 6px 45px;\n    display: inline-block;\n    width: 100%;\n    animation-name: left-to-right-slide-anim;\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    opacity: 0;\n\n    .card-warpper-info {\n        border-radius: 4px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        background: var(--card-main-wrapper-bg);\n        display: flex;\n        padding: 16px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 12px;\n\n        h1 {\n            color: var(--card-heading-title);\n            font-size: 14px;\n            font-weight: 600;\n            line-height: normal;\n        }\n    }\n}\n\n.card-content-sec {\n    display: flex;\n    padding: 12px;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n    border-radius: 4px;\n    border: 1px solid var(--card-temp-border);\n    background: var(--card-temp-bg);\n    text-align: start;\n\n    .top-sec-card {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        gap: 10px;\n\n        h1 {\n            color: var(--card-temp-h1-color);\n            font-size: 14px;\n            font-weight: 700;\n            line-height: normal;\n            width: 100%;\n        }\n\n        .tag-name {\n            flex-shrink: 0;\n            border-radius: 24px;\n            background: var(--sdk-gloabl-bg-secondary);\n            padding: 2px 10px;\n            color: var(--kore-green-kore-green-0, #04AF5F);\n            text-align: center;\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 18px;\n        }\n    }\n\n    .middle-sec-card {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n        width: 100%;\n\n        p {\n            color: var(--card-temp-p-color);\n            font-size: 10px;\n            font-weight: 400;\n            line-height: normal;\n            width: 100%;\n        }\n\n        .amount-text {\n            color: var(--card-temp-color);\n            text-align: right;\n            font-size: 10px;\n            font-weight: 500;\n            line-height: normal;\n            flex-shrink: 0;\n            max-width: 60%;\n        }\n\n        .clickble-text {\n            @extend .amount-text;\n            color: var(--sdk-global-theme-color);\n        }\n    }\n\n    .bottom-sec-card {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        width: 100%;\n\n        h2 {\n            overflow: hidden;\n            color: var(--card-temp-color);\n            font-size: 12px;\n            font-weight: 500;\n            line-height: normal;\n            width: 100%;\n        }\n\n        p {\n            color: var(--card-temp-color);\n            text-align: right;\n            font-size: 12px;\n            font-weight: 500;\n            line-height: normal;\n            flex-shrink: 0;\n        }\n    }\n\n    .more-sec-card {\n        @extend .bottom-sec-card;\n\n        h2 {\n            font-size: 10px;\n        }\n\n        p {\n            font-size: 10px;\n        }\n    }\n\n    .border-divider {\n        background: var(--card-temp-border-divided-bg);\n        width: 25px;\n        height: 1px;\n    }\n\n    .view-more-btn {\n        border-radius: 4px;\n        border: 1px solid var(--card-temp-view-more-border);\n        width: 100%;\n        background: var(--card-temp-view-more-bg);\n        padding: 5px 12px;\n        color: var(--card-temp-view-more-color);\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        height: 30px;\n        text-align: center;\n        margin-top: 5px;\n    }\n}\n\n.card-template-wrapper-view-more-details {\n    padding: 6px 12px 6px 45px;\n    display: inline-block;\n    width: 100%;\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n\n.menu-wrapper-data-actions{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    .actions-slider-header-menu{\n        display: flex;\n        align-items: center;\n        padding: 14px 15px;\n        gap: 10px;\n        flex-shrink: 0;\n        h1{\n            width: 100%;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 700;\n            line-height: normal;\n        }\n        .menu-close{\n            width: 16px;\n            height: 16px;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            svg{\n                path{\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n    .iner-data-scroll-wraper{\n        flex: 1 1 auto;\n        overflow: auto;\n    }\n}\n\n.card-info-more-details {\n    padding: 10px 15px;\n    display: flex;\n    flex-direction: column;\n\n    .m-b-10 {\n        margin-bottom: 10px;\n    }\n\n    .top-sec-card {\n        display: flex;\n        align-items: center;\n        margin-bottom: 12px;\n\n        h1 {\n            color: var(--sdk-gloabl-text-color);\n            font-size: 18px;\n            font-weight: 700;\n            line-height: 14px;\n            width: 100%;\n        }\n\n        span {\n            border-radius: 4px;\n            background: var(--sdk-gloabl-bg-secondary);\n            flex-shrink: 0;\n            color: var(--sdk-gloabl-text-color);\n            text-align: right;\n            font-size: 14px;\n            font-weight: 700;\n            line-height: normal;\n            padding: 5px;\n        }\n    }\n\n    .middle-sec-card, .bottom-sec-card {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        padding: 10px 0;\n\n        .img-with-text {\n            display: flex;\n            align-items: flex-start;\n            width: 100%;\n            gap: 10px;\n\n            img {\n                width: 16px;\n                height: 16px;\n                flex-shrink: 0;\n            }\n\n            p {\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 400;\n                line-height: normal;\n                width: 100%;\n            }\n        }\n\n        .right-title {\n            flex-shrink: 0;\n            display: flex;\n            align-items: flex-start;\n            gap: 14px;\n\n            p {\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 600;\n                line-height: 14px;\n            }\n\n            img {\n                width: 16px;\n                height: 16px;\n                flex-shrink: 0;\n            }\n        }\n    }\n\n    .small-font-sec {\n        @extend .middle-sec-card;\n        padding: 3px 0;\n\n        .img-with-text {\n            p {\n                font-size: 12px;\n            }\n        }\n\n        .right-title {\n            p {\n                font-size: 12px;\n                font-weight: 500;\n                line-height: 20px;\n            }\n        }\n    }\n\n    .medium-font-sec {\n        @extend .middle-sec-card;\n        margin-top: 5px;\n\n        .img-with-text {\n            p {\n                font-size: 14px;\n                line-height: 20px;\n                color: var(--sdk-gloabl-text-color);\n                font-weight: 500;\n            }\n        }\n\n        .right-title {\n            p {\n                font-size: 20px;\n                font-weight: 700;\n                color: var(--sdk-gloabl-text-color);\n            }\n        }\n    }\n}\n\n// Accordon styles\n\n.accordion-wrapper{\n    padding: 10px 15px;\n    display: inline-block;\n    width: 100%;\n    .accordion_item{\n        display: inline-block;\n        width: 100%;\n        border-radius: 6px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        margin: 2px 0;\n        .accordion_heading{\n            width: 100%;\n            text-align: start;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            min-height: 50px;\n            background: var(--sdk-gloabl-bg-secondary);\n            border: 0;\n            padding: 10px;\n            &[aria-expanded=\"true\"]{\n                .arrow-icon{\n                    transform:rotate(90deg);\n                }\n            }\n            p{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 600;\n                line-height: normal;\n                width: 100%;\n            }\n            .arrow-icon{\n                width: 16px;\n                height: 16px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                cursor: pointer;\n                svg{\n                    path{\n                        fill: var(--sdk-gloabl-text-color);\n                    }\n                }\n            }\n        }\n        .accordion_collapse{\n            transition: height .35s ease;\n            display: block;\n            -webkit-animation-name: slideOutDown;\n            animation-name: slideOutDown;\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n            &:not(.collapse_data){\n                display: none;\n                animation: none !important;\n            }\n            .accordion_body{\n                padding: 0 10px;\n            }\n        }\n    }\n}\n\n.card-acc-temp-sec{\n    .card-acc-temp{\n        display: flex;\n        width: 321px;\n        padding: 10px 10px 10px 0px;\n        align-items: flex-start;\n        gap: 15px;\n        border-bottom: 1px solid var(--sdk-gloabl-border-color);\n        &:last-child{\n            border: 0;\n        }\n        cursor: pointer;\n        .left-data{\n            width: 100%;\n            h1{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 500;\n                line-height: 20px;\n            }\n            p{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 13px;\n                font-weight: 400;\n                line-height: 20px;\n            }\n        }\n        .right-data{\n            flex-shrink: 0;\n            p{\n                color: var(--sdk-gloabl-text-color);\n                text-align: right;\n                font-size: 12px;\n                font-weight: 500;\n                line-height: 20px;\n            }\n        }\n    }\n}\n\n.regular-card-temp-container{\n    padding: 0 16px;\n    display: inline-block;\n    width: 100%;\n    .rugular-card-temp{\n        border-radius: 8px;\n        background: var(--sdk-global-white-bg);\n        display: inline-block;\n        width: 100%;\n        box-shadow: 0px 1px 2px 0px var(--sdk-gloabl-border-color);\n        .card-r-h-1{\n            width: 100%;        \n            display: flex;\n            align-items: normal;\n            padding: 10px;\n            gap: 15px;\n            .border-block{\n                width: 4px;\n                flex-shrink: 0;\n                border-radius: 9px;\n                background: var(--sdk-global-theme-color);\n            }\n            .img-block{\n                flex-shrink: 0;\n                width: 40px;\n                height: 40px;\n                &.xs{\n                    width: 16px;\n                    height: 16px;\n                }\n                &.lg{\n                    width: 60px;\n                    height: 60px;     \n                }\n                &.xlg{\n                    width: 80px;\n                    height: 80px;\n                }\n                figure{\n                    line-height: 0px;\n                }\n                img{\n                    width: 100%;\n                    height: 100%;\n                    border-radius: 8px;\n                    &.radius-100{\n                        border-radius: 100%;\n                    }\n                }\n            }\n            .titles-info-block{\n                width: 100%;\n                // overflow: hidden;\n                // white-space: nowrap;\n                // text-overflow: ellipsis;\n                h1{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 16px;\n                    font-weight: 600;\n                    line-height: normal;\n                    // overflow: hidden;\n                    // white-space: nowrap;\n                    // text-overflow: ellipsis;\n                    // width: 100%;\n                }\n                p{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 400;\n                    line-height: normal;\n                    letter-spacing: 0.271px;\n                    // overflow: hidden;\n                    // white-space: nowrap;\n                    // text-overflow: ellipsis;\n                    // width: 100%;\n                }\n            }\n        }\n        .r-header-card{\n            border-radius: 8px 8px 0px 0px;\n            background: var(--sdk-gloabl-bg-secondary);\n            padding: 14px;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 500;\n            line-height: 20px;\n            border: 1px solid var(--sdk-gloabl-border-color);\n            h1{\n                margin: 0;\n            }\n        }\n        .r-body-card{\n            padding: 10px 14px;\n            border: 1px solid var(--sdk-gloabl-border-color);\n            border-radius: 0px 0px 8px 8px;\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            gap: 8px;\n            .row-list-info{\n                display: flex;\n                align-items: flex-start;\n                gap: 14px;\n                figure{\n                    line-height: 0;\n                    position: relative;\n                    top: 2px;\n                    img{\n                        width: 16px;\n                        height: 16px;\n                    }\n                }\n                p{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 19px;\n                    letter-spacing: 0.3px;\n                }\n            }\n        }\n        .btn-action-card{\n            width: 100%;\n            border-radius: 0px 0px 8px 8px;\n            background: var(--sdk-global-theme-color);\n            border: 1px solid var(--sdk-global-theme-color);\n            padding: 13px;\n            text-align: center;\n            color: var(--sdk-global-white);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
